import { useFeatureFlagEnabled } from "@posthog/react";

import { getFeatureFlagDefault } from "../constants/buildFlags";
import { FeatureFlag } from "../constants/featureFlags";

export function useFeatureFlag(flag: FeatureFlag): boolean {
  const flagValue = useFeatureFlagEnabled(flag);
  return flagValue === undefined ? getFeatureFlagDefault(flag) : flagValue;
}
